exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".install-modal .center-content {\n  text-align: center; }\n  .install-modal .center-content .muted {\n    margin-top: 20px;\n    color: #D4D4D4; }\n", ""]);

// exports
